<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户名称" prop="userId" >
       <a-select :disabled="isSend == true" v-model="form.userId" show-search allow-clear :filter-option="filterOption">
         <a-select-option v-for="item in userList" :value="item.id" :key="item.id">
           {{ item.nickname }} - {{ item.mobile }}
         </a-select-option>
       </a-select>
       <!-- <a-select
         placeholder="选择用户名称"
         style="width: 500px"
         show-search
         allow-clear
         @change="initUser"
         @search="dinnerSelect"
         :filterOption="false"
       >
         <a-select-option :value="item.id" v-for="item in userList" >
           {{ item.name }}
         </a-select-option>
       </a-select> -->
      </a-form-model-item>
      
      <a-form-model-item label="现金券数量" prop="voucher" >
        <a-input-number :min="1" style="width: 200px" v-model="form.voucher" placeholder="请输入现金券数量" />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVoucher, addVoucher, updateVoucher,sendVoucher } from '@/api/user/voucher'
import {listUser} from "@/api/biz/user";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      userList:[],
      isSend:false,
      // 表单参数
      form: {
        id: null,

        voucher:1,
        userId:null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        voucher: [
          { required: true, message: '现金券数量不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initUser()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
    onClose () {
      this.open = false
      this.reset()
    },
    initUser(){
      listUser({status:1}).then(res=>{
        this.userList = res.data
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.isSend = false
      this.formType = 1
      this.form = {
        id: null,
        voucher: null,
        userId:null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '赠送'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.isSend = true
      getVoucher({id:id}).then(res=>{
        this.form.id = id
        this.form.userId = res.data.userId
      })
      this.formTitle = '赠送'
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          sendVoucher(this.form).then(response => {
            this.$message.success(
              '操作成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
